<template>
    <div :class="$style.content">
        <img
            :src="FennekImg"
            alt="fennec"
            :class="$style.icon"
        />
        <div :class="$style.info">
            <Typography
                accent
                responsive
                size="s"
                :class="$style.text"
            >
                {{ $tr('instreamWrapper.info') }}
            </Typography>
            <div :class="$style.sub_info">
                <Typography
                    v-if="secondsLeft > 0"
                    responsive
                    size="xs"
                    :class="$style.subtext"
                >
                    {{ secondsLeft }}
                    {{ $tr('instreamWrapper.sec') }}
                </Typography>
                <Typography
                    v-if="showAdCounter"
                    responsive
                    size="xs"
                    :class="$style.subtext"
                >
                    {{ adCounterLabel }}
                </Typography>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'

import Typography from '@/components_new/Typography.vue'
import { useTr } from '@/composables/use-tr'

import FennekImg from './fennec.webp'

const props = defineProps<{
    secondsLeft: number
    currentAd: number
    totalAds: number
}>()

const tr = useTr()

const showAdCounter = computed(() => {
    return props.totalAds > 1
})
const adCounterLabel = computed(() =>
    showAdCounter.value
        ? `(${tr('instreamWrapper.adCounter', {
              current: `${props.currentAd}`,
              total: `${props.totalAds}`,
          })})`
        : '',
)
</script>
<style module>
.content {
    --footer-height: 56px;
    position: absolute;
    z-index: 2;
    bottom: 0;
    left: 0;
    width: 100%;
    color: white;
    box-sizing: border-box;
    background: var(--carbon-300);
    border-bottom: 1px solid var(--carbon-400);
    height: var(--footer-height);
    font-size: 14px;
    display: flex;
    justify-content: start;
    align-items: center;
}
.icon {
    width: 36px;
    height: 36px;
    margin: 0 12px 0 16px;
}
.info {
    display: flex;
    flex-direction: column;
    gap: var(--gap-4);
}
.sub_info {
    display: flex;
    gap: var(--gap-4);
}
.text {
    color: white;
}
.subtext {
    color: var(--carbon-500);
}

@media (--mobile) {
    .text {
        font-size: var(--font-size-label-s);
    }
    .subtext {
        font-size: var(--font-size-label-xs);
    }
}
</style>
